export const TranslationsNL = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesië',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KRO',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
    },
    // BASE
    phrases: {
        order_online: 'Bestel online',
        cart: 'Winkelwagen',
        open_24: '24 uur',
        closed: 'Gesloten',
        free: 'VRIJ',
        something_went_wrong: 'Er is iets misgegaan',
        try_again: 'probeer het opnieuw',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Maandag',
                tuesday: 'Dinsdag',
                wednesday: 'Woensdag',
                thursday: 'Donderdag',
                friday: 'Vrijdag',
                saturday: 'Zaterdag',
                sunday: 'Zondag',
            },
        },
        services: {
            pickup: 'Ophalen',
            delivery: 'Levering',
            dine_in: 'Dineren',
            table_booking: 'Tafelboeking',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Creditcard',
                paypal: 'PayPal',
                cardconnect: 'Creditcard',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Scheermes betalen',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Movil',
                custom: 'Custom',
                red_dot: 'Red Dot-betaling',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA-betaling',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva-portemonnee',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Movil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Scheermes betalen',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot-betaling',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA-betaling',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva-portemonnee',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Succes',
                pending: 'In behandeling',
                error: 'Fout',
                refunded: 'Terugbetaald',
                refunding: 'Terugbetaling',
                partial_refunded: 'Gedeeltelijk verdiend',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Verwijderen',
                drop_here: 'Zet uw bestanden hier neer of klik om er een te selecteren',
                accepts: 'Accepteert {{fileTypes}} bestanden',
                errors: {
                    max_files: 'Maximaal {{number}} toegestaan',
                    max_size: 'Maximale bestandsgrootte van {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'De winkel is momenteel gesloten en een bestelling voor een diner die onmiddellijk moet worden ingeleverd, kan niet worden geplaatst. U kunt in plaats daarvan proberen om voor een latere datum en tijd te bestellen',
            },
            buttons: {
                order: {
                    book_order: 'Reserveer tafel / Bestel online',
                    order_online: 'Bestel online',
                    book_table: 'Reserveer een tafel',
                    order: 'Volgorde',
                    book: 'Boek',
                    cart: 'Winkelwagen',
                    restart: 'Opnieuw opstarten',
                    closed: 'Winkel gesloten',
                    not_accepting: 'Bestellingen niet accepteren',
                },
            },
        },
        modals: {
            auth: {
                login: 'Inloggen',
                register: 'Registreren',
                register_commence: 'Doorgaan',
                register_complete: 'Account aanmaken',
                register_confirmation_sent: 'Er is een bevestigingscode naar uw e-mailadres verzonden. Vul het hieronder in om verder te gaan',
                register_confirmation_resent: 'De bevestigingscode is opnieuw verzonden, controleer uw spam of start het proces opnieuw',
                register_restart: 'Opnieuw opstarten',
                register_resend_code: 'Code opnieuw verzenden',
                register_confirmation_code_subject: 'E-mailbevestigingscode',
                register_confirmation_code_email: 'Uw e-mailbevestigingscode is {{confirmation_code}} (loopt ruim 24 uur)',
                login_placeholder: 'E-mail',
                password_placeholder: 'Wachtwoord',
                confirm_password_placeholder: 'Bevestig wachtwoord',
                confirmation_code_placeholder: 'E-mailbevestigingscode',
                accept_terms: 'Accepteer Algemene voorwaarden',
                accept_terms_view: 'Weergave',
                login_facebook: 'Inloggen met Facebook',
                login_google: 'Inloggen met Google',
                benefits: 'Login of maak een account aan om al uw bestellingen op te slaan',
                logged_in: 'Succesvol ingelogd',
                logged_out: 'Uitgelogd',
                password_reset: {
                    init_button: 'Stuur een e-mail voor het opnieuw instellen van het wachtwoord',
                    init_success: 'De link voor het opnieuw instellen van het wachtwoord wordt naar uw e-mailadres verzonden',
                    complete_button: 'Wachtwoord opnieuw instellen',
                    complete_success: 'Wachtwoord opnieuw ingesteld, log in met uw nieuwe wachtwoord',
                    forgot_password_text: 'Wachtwoord vergeten?',
                    forgot_password_link: 'Wachtwoord opnieuw instellen',
                    remember_password_text: 'Onthoud uw wachtwoord?',
                    remember_password_link: 'Ga terug',
                    invalid_title: 'Wachtwoord opnieuw instellen Ongeldig',
                    invalid_description: 'Deze link voor het opnieuw instellen van het wachtwoord is niet geldig. Vraag ter plaatste daarvan een nieuwe aan',
                    invalid_link: 'Ga naar Inloggen',
                    title: 'Wachtwoord opnieuw instellen',
                    description: 'Voer een nieuw wachtwoord in voor uw account',
                },
                error_generic: 'Er is iets misgegaan, probeer het opnieuw of neem contact met ons op',
                error_accept_terms: 'Accepteer alstublieft de algemene voorwaarden',
                error_password_length: 'Minimaal 6 tekens voor wachtwoord',
                error_social: 'Er is iets misgegaan, probeer het opnieuw of neem contact met ons op',
                error_confirmation_code: 'Ongeldige bevestigingscode',
                error_invalid_code: 'Ongeldige bevestigingscode',
                error_exists: 'Gebruiker bestaat al',
                error_invalid_email_pass: 'Ongeldig e-mailadres of wachtwoord',
                error_password_no_match: 'Wachtwoorden komen niet met elkaar overeen',
                error_user_not_found: 'Geen gebruiker met dat e-mailadres',
                error_invalid_email: 'Ongeldig e-mailadres',
                error_invalid_reset_token: 'Ongeldige resetlink, vraag een nieuwe aan',
            },
            booking: {
                form: {
                    name: 'Volledige naam',
                    email: 'E-mailadres',
                    phone: 'Telefoonnummer',
                    number_of_people: 'Aantal mensen',
                    number_of_people_max: 'Aantal personen ({{max_people}} Max)',
                    number_of_people_min: 'Aantal personen ({{min_people}} min)',
                    number_of_people_max_min: 'Aantal personen (tussen {{min_people}} en {{max_people}})',
                    notes: 'Opmerkingen / Speciale aanvragen',
                    submit: 'Boekingsaanvraag indienen',
                    email_optional: '(optioneel)',
                    date: 'Datum',
                    duration: 'Duur',
                    seating: 'Beschikbare tijden',
                    number_of_guests: 'Aantal gasten',
                    notes_placeholder: 'Allergieën, gelegenheid, zitplaatsvoorkeur',
                    reserving: 'Reserveren...',
                    reserve_table: 'Tafel reserveren',
                    please_choose_a_date_and_time: 'Kies een datum en een tijd.',
                    invalid_people: 'Het aantal personen moet tussen {{min}} en {{max}} liggen.',
                    party_size_max_fallback: 'het toegestane maximum',
                    loading_available_times: 'Beschikbare tijden laden…',
                    select_a_date_to_see_available_times: 'Selecteer een datum om beschikbare tijden te zien.',
                    no_times_available_for_this_date: 'Geen tijden beschikbaar voor deze datum. Kies een andere dag.',
                    shift: 'Dienst',
                    service_times: 'Servicetijden',
                    new_shift: 'Nieuwe dienst',
                    time: 'tijd',
                    times: 'tijden',
                    unavailable: 'Niet beschikbaar',
                    available: 'Beschikbaar',
                    required_name: 'Vul je naam in.',
                    required_phone: 'Vul je telefoonnummer in.',
                    required_email: 'Vul je e-mailadres in.',
                    invalid_email: 'Vul een geldig e-mailadres in.',
                    required_terms: 'Accepteer de voorwaarden voordat je reserveert.',
                    reservation_is_unavailable: 'Reserveren is niet beschikbaar.',
                    please_contact_the_restaurant_directly: 'Neem rechtstreeks contact op met het restaurant.',
                    almost_done: 'Bijna klaar',
                    your_details: 'Jouw gegevens',
                    tell_us_who_s_coming: 'Vertel ons wie er komt, zodat we je reservering kunnen bevestigen.',
                    book_your_table: 'Reserveer je tafel',
                    choose_a_time_that_works_for_you: 'Kies een tijd die jou uitkomt.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Stuur je reserveringsaanvraag en het restaurant regelt de rest.',
                    select_date: 'Datum selecteren',
                    standard: 'Standaard',
                    minutes: 'minuten',
                    next: 'Volgende →',
                    back: '← Terug',
                    accept_terms: 'Ik accepteer de algemene voorwaarden.',
                    info_1: 'U ontvangt een e-mailmelding wanneer uw boeking wordt geaccepteerd of toegewezen',
                },
                errors: {
                    not_found: "Boeking bestaat niet. Deze is mogelijk verwijderd",
                    generic: 'Er is iets misgegaan, ververs de pagina van neem contact met ons op',
                    something_went_wrong: 'Er is iets misgegaan',
                    accept_terms: 'Accepteer alstublieft de algemene voorwaarden',
                    required_phone: 'Voer uw telefoonnummer in',
                    required_email: 'Voer uw e-mailadres in',
                    required_zip: 'Voer uw postcode in voor facturering in',
                    required_name: 'Voer uw naam in',
                    invalid_email: 'Voer een geldig e-mailadres in',
                    invalid_phone: 'Voer een onbeperkt telefoonnummer in',
                    invalid_people: 'Geldig aantal personen',
                    missing_custom_fields: 'Vul alle verplichte velden in.',
                    booking_capacity_threshold: 'We zijn volgeboekt voor dit tijdstip. Probeer een ander tijdstip.',
                    slot_unavailable: 'We zijn volgeboekt voor dit aantal personen. Probeer een ander tijdstip.',
                    booking_date_paused: 'Reserveringen zijn gepauzeerd voor deze datum. Kies een andere dag.',
                    invalid_table_assignment: 'Die tafels bieden niet genoeg plaats voor je gezelschap. Kies een andere tijd.',
                    exceeded_order_limit: 'Te veel reserveringsaanvragen. Probeer het later opnieuw.',
                    validation_failed_recaptcha_v3: 'Ongewoon verkeer gedetecteerd. Gebruik je een VPN? Voltooi de controle hierboven en probeer het opnieuw.',
                    validation_failed_recaptcha_v2: 'De reservering kon niet worden gestart. Probeer het opnieuw of gebruik een andere methode. Als je een VPN gebruikt, schakel die dan eerst uit.',
                    booking_already_exists: 'Deze reservering is al verzonden. Controleer je e-mail of open je reserveringslink.',
                    invalid_party_size: 'Kies een geldig aantal personen.',
                    invalid_request: 'Ongeldige aanvraag. Vernieuw de pagina en probeer het opnieuw.',
                    table_booking_unavailable: 'Tafelreservering is niet beschikbaar.',
                },
            },
            cart: {
                title: 'Winkelwagen',
                proceed_to_checkout: 'Ga verder naar afrekenen',
                edit_dish: 'Bewerking',
                remove_dish: 'Verwijderen',
                no_items_1: 'Geen artikelen in winkelwagen',
                no_items_2: 'Voeg er eerst wat toe om verder te gaan',
                free_delivery_notice: 'Gratis bezorging voor bestellingen boven {{value, currency}}',
                errors: {
                    min_order_promo: 'Minimale winkelwagenwaarde van {{value, currency}} vereist voordat deze promotie wordt toegepast',
                    min_order_delivery: 'Minimale winkelwagenwaarde van {{value, currency}} voor bezorging',
                },
                promo: {
                    heading: 'Promotiecode',
                    placeholder: 'Voer uw promotiecode in',
                    add: 'Code toevoegen',
                    title: 'Promo {{name}} toegevoegd aan winkelwagen',
                    fixed_discount: '{{value, currency}} Uit',
                    percent_discount: '{{value}}% korting',
                    added_to_cart: 'Promo toegevoegd aan winkelwagen',
                    errors: {
                        not_found: 'Promo niet gevonden',
                        disabled: 'Promo is uitgeschakeld',
                        not_available: 'Promo is momenteel niet beschikbaar',
                        not_eligible: 'Komt niet in aanmerking voor het toepassen van de promotiecode',
                        not_available_time: 'Promo levert deze keer niet op',
                        logged_in_only: 'Om van deze promo gebruik te kunnen maken, moet je ingelogd zijn',
                        already_used: 'Je hebt deze promotie al gebruikt',
                        invalid: 'Deze actie is niet langer geldig',
                        invalid_service: 'Deze promotie is niet geldig voor de door u gekozen dienst',
                        later_only: 'Alleen geldig op pre-orders',
                        now_only: 'Alleen geldig voor bestellingen die onmiddellijk moeten worden betaald, niet voor pre-orders',
                        generic: 'Oeps... er is iets misgegaan en het is geregistreerd',
                        dishes_required_multi: 'Deze promotie wordt alleen toegepast als bepaalde artikelen aan uw winkelwagen worden toegevoegd',
                        dishes_required_single: "Deze promotie is alleen van toepassing op '{{dish}}'"
                    },
                },
                tip: {
                    title: 'Besteltip',
                    placeholder: 'Voeg een besteltip toe',
                },
            },
            free_items_promo: {
                title: 'Gratis artikelen',
                usage_confirmation: {
                    question: 'U komt in aanmerking voor gratis artikelen. Wil je ze zien en toevoegen?',
                    cancellation: "Nee, ik wil geen gratis artikelen",
                    acceptance: 'Ja',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Selecteer {{number}} gratis artikel(en)',
                    },
                    single: {
                        description: 'Selecteer een gratis artikel',
                    },
                    confirm_button: 'Bevestigen',
                },
            },
            checkout: {
                title: 'Afrekenen',
                subtitle: 'Bevestig uw bestelgegevens',
                details: {
                    service: 'Dienst',
                    due: 'Vanwege',
                    due_now_asap: 'Nu/zo snel mogelijk',
                    address: 'Afleveradres',
                    total: 'Totaal',
                    table: 'Tafel',
                    store_location: 'Winkeladres',
                },
                customer: {
                    title: 'Klant',
                    subtitle: 'Log in om uw bestelling en gegevens op te slaan',
                    button: 'Inloggen',
                    name: 'Volledige naam',
                    email: 'E-mail',
                    phone: 'Telefoon',
                    phone_important: 'Telefoon (belangrijk)',
                    notes: 'Bestelnotities',
                    delivery_notes: 'Leveringsinstructies/bestelnotities',
                    optional: 'optioneel',
                },
                payment: {
                    title: 'Betaalmethode',
                    qr_modal_help: 'Gebruik uw mobiele applicatie {{app}} om de QR te scannen en de betaling voor deze bestelling te voltooien. Zodra de betaling op uw mobiele applicatie is voltooid, kunt u deze QR-modale sluiten. Sluit deze QR-modaliteit niet af als u uw betalingsproces nog niet heeft voltooid.',
                    switch_to_app_help: 'Door op de onderstaande knop te drukken, wordt de mobiele applicatie {{app}} automatisch geopend om de betaling voor deze bestelling te voltooien. Zodra de betaling op uw mobiele applicatie is voltooid, kunt u deze modaliteit sluiten. Sluit deze modaliteit niet af als u uw betalingsproces nog niet heeft afgerond.',
                    open_app: 'Open de {{app}}-applicatie',
                    continue: 'Doorgaan',
                    continue_to_payment: 'Ga verder naar {{method}}',
                    back_to_cart: 'Terug naar winkelwagen',
                },
                accept_terms: 'Accepteer Algemene voorwaarden',
                accept_terms_view: 'Weergave',
                processing_order: 'Bestelling verwerken',
                warning: {
                    different_payment_currency: 'Winkelprijzen zijn in {{store_currency}}, maar de betaalmethode is in {{payment_currency}}',
                    closing_soon: 'gesloten gesloten, bestellingen moeten binnen {{value}} minuten worden geplaatst',
                    closed: 'Sorry, deze service is gesloten en bestellingen worden niet geaccepteerd',
                    paused: 'Sorry, deze service is beperkt en bestellingen worden momenteel niet geaccepteerd',
                    expired: 'We kunnen uw bestelling niet langer op het door u geselecteerde uitvoeren. Kies een later datum van tijd',
                },
                errors: {
                    walletly_promo: 'Walletly-promo bevat een fout. Probeer een andere promo!',
                    stripe_generic: 'Creditcardfout, probeer het opnieuw of gebruik een andere methode',
                    validation_failed: 'Deze betaling kan op dit moment niet worden geaccepteerd. Probeer het later opnieuw of kies een andere betaalmethode.',
                    validation_failed_recaptcha_v3: 'Ongebruikelijk verkeer verplicht. Gebruikt u een VPN? Voltooi de bovenstaande uitdaging en probeer het opnieuw.',
                    validation_failed_recaptcha_v2: 'We konden de betaling niet starten. Probeer het opnieuw of gebruik een andere methode. Als je een VPN gebruikt, probeer dan deze dan eerst uit te schakelen.',
                    stripe_loading_fail: 'Fout bij het laden van het betalingsformulier. Probeer het opnieuw',
                    something_went_wrong: 'Er is iets misgegaan',
                    paypal_generic: 'Er is iets misgegaan met PayPal, probeer het opnieuw of kies een andere betaalmethode',
                    payment_fail: 'Betaling mislukt. Probeer het opnieuw of selecteer een andere betaalmethode',
                    payment_cancelled: 'Betaling geannuleerd. Probeer het opnieuw of selecteer een andere betaalmethode',
                    payment_error: 'Fout bij het verwerken van de online betaling. Probeer het opnieuw of kies een andere betaalmethode',
                    payment_declined: 'Uw betaalmethode is gedefinieerd',
                    card_declined: "Uw kaart is afgewezen en de betaling kan niet worden verwerkt",
                    promo_max_uses_exceeded: "Deze promocode heeft de gebruikslimiet bereikt en is niet meer beschikbaar.",
                    store_closed: 'De winkel is gesloten en neemt geen bestellingen meer aan',
                    accept_terms: 'Accepteer alstublieft de algemene voorwaarden',
                    required_payment: 'Selecteer een betaalmethode',
                    required_phone: 'Voer uw telefoonnummer in',
                    required_email: 'Voer uw e-mailadres in',
                    required_zip: 'Voer uw postcode in voor facturering in',
                    required_name: 'Voer uw naam in',
                    invalid_email: 'Voer een geldig e-mailadres in',
                    invalid_phone: 'Voer een onbeperkt telefoonnummer in',
                    invalid_cc_number: 'Uw creditcardnummer is geverifieerd',
                    invalid_order_amount: 'Minimaal vereist bedrag voor deze betaalmethode',
                    retry_cc_number: 'Er is iets misgegaan. Voer uw creditcardnummer opnieuw in en probeer het opnieuw',
                    closed: 'De winkel is gesloten en neemt geen bestellingen aan',
                    promo_login_required: 'Om van deze promo gebruik te kunnen maken, moet je ingelogd zijn',
                    promo_used: 'Je hebt deze promotie al gebruikt',
                    promo_by_payment_method_not_applicable: 'Promo is niet van toepassing op de geselecteerde betaalmethode.',
                    missing_custom_checkout_fields: 'Vul alle verplichte velden in.',
                    delivery_unavailable: 'De bezorgservice is op dit moment mogelijk niet beschikbaar. Overweeg dan om in plaats daarvan een afhaalbestelling te doen.',
                    required_delivery_provider: 'Kies een dienstlevering.',
                    required_delivery_quotation: 'Leveringsschatting verlopen.',
                    exceeded_order_limit: 'Krijgen momenteel wij veel bestellingen binnen. Kies een later begin.',
                    exceeded_order_limit_later: 'We kunnen uw bestelling niet langer op het door u geselecteerde uitvoeren. Kies een later datum van tijd',
                },
                button: {
                    continue: 'Ga verder naar betaling',
                    place_order: 'Bestelling plaatsen',
                    update_order: 'Bestelling bijwerken',
                },
                delivery_estimation: {
                    title: 'Leveringsschatting',
                    details: {
                        provider: 'Bezorgaanbieder',
                        estimated_fee: 'Geschatte vergoeding',
                        estimated_total_fee: 'Bezorgkosten Totaal',
                        estimated_discount_fee: 'Korting op bezorgkosten',
                        previous_estimated_fee: 'Vorige vergelijkbare vergoeding',
                        tips: 'Tips',
                        estimated_delivery_time: 'Geschatte levering',
                        uber_new_estimation: 'Vraag een nieuwe berekening aan',
                        uber_new_estimation_success: 'Nieuwe berekening van Uber-bezorging toegepast.',
                        uber_estimation_expired: 'Leveringsschatting verlopen',
                        uber_price: 'Wij houden de Uber-prijs groot',
                        uber_need_time: 'Ik heb meer tijd nodig',
                        lalamove_price: 'Wij houden de bezorgkosten van Lalamove enorm',
                        lalamove_new_estimation_success: 'Nieuwe Lalalmove-leveringsschatting toegepast.',
                        lalamove_estimation_expired: 'Leveringsschatting verlopen',
                        lalamove_need_time: 'Ik heb meer tijd nodig',
                        lalamove_new_estimation: 'Vraag een nieuwe berekening aan',
                    },
                    quotation_error: 'Er is iets misgegaan bij het berekenen van de geschatte bezorging.',
                },
            },
            customer: {
                age_v: {
                    title: 'Leeftijdsverificatie',
                    required_for_items: 'Verplicht om bepaalde artikelen te bestellen',
                    min_age: 'Minimumleeftijd: {{age}} jaar',
                    est_time: 'Geschatte vervaltijd: {{time}} uur',
                    upload_description: 'Upload hieronder uw identiteitsbewijs ter verificatie. Zodra u bent geverifieerd, wordt u per e-mail op de hoogte gesteld. Upload maximaal 2 afbeeldingen met een maximale grootte van 2 MB elk',
                    pending_description_1: 'Bedankt voor het indienen van uw documenten. Wanneer u wordt goedgekeurd, ontvangt u per e-mail bericht',
                    pending_description_2: 'Vernieuw de pagina om uw verificatiestatus bij te werken. De geschatte verificatietijd is {{time}} uur',
                    approved_description: 'Uw account is feitelijk en u kunt bestellen via beperkte menu\'s',
                    rejected_description: 'Uw identiteitsbewijs is gezamenlijk. Als u het opnieuw wilt proberen, upload dan uw identiteitsbewijs opnieuw',
                    upload: 'Uploaden',
                    reupload: 'Documenten opnieuw uploaden',
                    go_back: 'Ga terug',
                    view_document: 'Bekijk document {{number}}',
                    status: {
                        unverified: 'Niet-geverifieerd',
                        pending: 'Wachten op goedkeuring',
                        approved: 'Succesvol relevant',
                        rejected: 'Afgewezen',
                    },
                },
                headings: {
                    sessions: 'Sessies',
                    orders: 'Volgorde',
                    spend: 'Uitgeven',
                    order_history: 'Bestelgeschiedenis',
                    loyalty: 'Loyaliteit',
                    loyalty_points: 'Loyaliteitspunten',
                    added: 'Promo toegevoegd.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Kies een item voordat je het inwisselt!',
                    not_found: 'Promo niet gevonden!',
                    already_exists: 'Promo bestaat al!',
                    try_again: 'Kan deze deal niet toepassen. Probeer het opnieuw!',
                },
            },
            custom_payment: {
                title: '{{name}} Betalingsformulier',
                description: 'U bent op ons online betalingsformulier terechtgekomen. Vul onderstaande velden in om een ​​betaling uit te voeren. Als er geen bedrag is ingevuld, worden uw gegevens bewaard, maar worden er geen kosten in rekening gebracht.',
                disabled: 'Deze online betaalpagina is niet correct geconfigureerd. Neem contact op met de site-eigenaar om het probleem op te lossen.',
                success: 'Uw betaling is succesvol verwerkt en uw gegevens zijn opgeslagen. Bedankt',
                back: 'Terug naar huis',
                fields: {
                    name: 'Volledige naam',
                    email: 'E-mailadres',
                    reference: 'Betalingsref.',
                    amount: 'Bedrag ($)',
                    name_on_card: 'Naam op kaart',
                    submit: 'Betaling indienen',
                },
                warning: {
                    currency: 'Opmerking: betalingsbedrag in {{actual}}, niet in {{default}}',
                },
                errors: {
                    generic: 'Er is iets misgegaan, probeer het opnieuw of neem contact met ons op',
                    stripe_generic: 'Creditcardfout, vernieuw de pagina en probeer het opnieuw',
                    payment_fail: 'Betaling mislukt. Probeer het opnieuw of selecteer een andere betaalmethode',
                    payment_cancelled: 'Betaling geannuleerd. Probeer het opnieuw of selecteer een andere betaalmethode',
                    payment_error: 'Fout bij het verwerken van de online betaling. Probeer het opnieuw of kies een andere betaalmethode',
                    payment_declined: 'Uw betaalmethode is gedefinieerd',
                    card_declined: "Uw kaart is afgewezen en de betaling kan niet worden verwerkt",
                    promo_max_uses_exceeded: "Deze promocode heeft de gebruikslimiet bereikt en is niet meer beschikbaar.",
                },
            },
            dish: {
                add: 'Voeg toe aan winkelwagen',
                edit: 'Artikel bijwerken',
                notes: 'Speciale instructies...',
                ingredients: {
                    title: 'Ingrediënten',
                    uncheck_remove: 'Haal het vinkje weg om te verwijderen',
                },
                ingredients_title: 'Ingrediënten',
                combo: {
                    choose_dish: 'Kies een artikel',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Selecteer er één (vereist)',
                        select_one_optional: 'Selecteer er één (optioneel)',
                        select_between: 'Kies tussen {{min}} - {{max}} (vereist)',
                        select_at_least: 'Selecteer minimaal {{qty}} (vereist)',
                        select_up_to: 'Selecteer maximaal {{qty}} (optioneel)',
                        select_multiple_optional: 'Selecteer meerdere (optioneel)',
                        select_multiple: 'Selecteer meerdere (vereist)',
                        free_amount: 'Eerste {{qty}} Gratis / {{selected}} Gekozen',
                    },
                    points: {
                        none_consumed: 'U kunt gratis maximaal {{maxFree}} opties kiezen',
                        less_than_total_points: 'U kunt gratis meer opties kiezen',
                        greather_than_total_points: 'Tegen een toeslag kunt u meer opties kiezen',
                    },
                },
                error: 'Corrigeer eventuele rood gemarkeerde opties',
                added_to_cart: 'Artikel toegevoegd aan winkelwagen',
            },
            map: {
                zone_fee: 'Bezorgkosten',
                view_in_google: 'Bekijk in Google Maps',
            },
            portal_go_back: {
                title: 'Terug naar restaurant zoeken?',
                description: 'Alle artikelen in uw winkelwagen gaan verloren',
                cancel: 'Annuleren',
                proceed: 'Ga terug',
            },
            order: {
                config: {
                    services: {
                        title: 'Kies een dienst',
                        table_booking: 'Boektafel',
                    },
                    address_custom: {
                        input_placeholder: 'Voer uw adres in',
                    },
                    address: {
                        input_placeholder: 'Vind uw afleveradres',
                        extras_placeholder: 'Unitnummer, naam van het gebouw, leveringsinstructies, enz...',
                        search_placeholder: 'Zoek naar uw adres',
                        search_input_placeholder: 'Typ om te zoeken',
                        no_address_found: 'Geen adressen gevonden. Probeer meer dan 5 tekens te typen',
                        not_found: 'Afleveradres niet gevonden of geldig, probeer het opnieuw',
                        not_delivering: 'Tijdelijk leveren wij niet op dit adres',
                        not_in_range: 'Uw adres ligt niet binnen het bereik van onze winkellocatie',
                        not_in_zone: 'Uw adres bevindt zich niet in een actieve bezorgzone',
                        no_number: 'Uw adres moet een huisnummer hebben',
                        location_permission: 'Deze website toegang geven tot uw huidige locatie?',
                        location_permission_warning: "U kunt uw huidige locatie niet openen. Schakel de locatieservice in op uw apparaat en webbrowser. Hier zijn enkele referenties:",
                        pick_location: 'Kies uw locatie',
                        pick_location_help_text: 'Versleep de markering om een ​​locatie op de kaart te kiezen.',
                        use_current_location: 'Gebruik huidige locatie',
                        locate_on_map: 'Zoek op kaart',
                    },
                    datetime: {
                        title: 'Wanneer u uw bestelling wilt ontvangen',
                        due_now: 'Nu',
                        due_later: 'Later',
                        service_not_available: 'Sorry, wij accepteren momenteel geen bestellingen voor {{service}}',
                        currently_closed: '{{service}} momenteel gesloten, maar je kunt bestellen voor later',
                        due_unavailable: 'Niet beschikbaar',
                        due_closed: 'Gesloten',
                        select_date: 'Selecteer Datum',
                        select_time: 'Selecteer Tijd',
                        select_order_date: 'Selecteer uw besteldatum',
                        select_order_time: 'Selecteer uw besteltijd',
                        select_order_date_time: 'Selecteer uw besteldatum/-tijd',
                        select_booking_date: 'Selecteer uw boekingsdatum',
                        select_booking_time: 'Selecteer uw boekingstijd',
                        no_times_available: 'Er zijn geen tijden beschikbaar om uit te kiezen',
                        date_today: '(Vandaag)',
                        date_closed: '(Gesloten)',
                        date_bookings_paused: '(Reserveringen gepauzeerd)',
                        time_slot_closed: 'Gesloten',
                    },
                    number_of_people: {
                        placeholder: 'Aantal mensen',
                    },
                    table: {
                        select: 'Selecteer Tabel',
                        select_popup_title: 'Selecteer uw tafel',
                        password: 'Tabelwachtwoord',
                        password_warning: 'Voer uw tafelwachtwoord in om door te gaan',
                    },
                    warning: {
                        closed: 'Sorry, wij zijn momenteel gesloten / accepteren geen bestellingen',
                        not_available: 'Sorry, wij accepteren momenteel geen bestellingen',
                    },
                    eta: {
                        delivery: `De geschatte levertijd bedraagt ​​{{minutesToCustomer}} minuten`,
                        pickup: `De bestelling is ruim ongeveer {{minutesToCustomer}} minuten klaar`,
                    },
                    start_button: 'Bestelling starten',
                },
                history: {
                    invalid: 'Kan niet opnieuw worden besteld, omdat sommige bestelde artikelen zijn gewijzigd of niet langer beschikbaar zijn',
                },
                reorder: {
                    title: 'Snel opnieuw bestellen',
                    description: 'Bestel eenvoudig de artikelen uit uw geplande bestellingen',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Bestelling niet gevonden, vernieuw de pagina en probeer het opnieuw',
                    booking_not_found: 'Reservering bestaat niet. Mogelijk is deze verwijderd',
                    generic: 'Er is iets misgegaan, ververs de pagina van neem contact met ons op',
                },
                connection: {
                    connected: 'Realtime-updates',
                    connecting: 'Realtime updates verbinden',
                    disconnected: 'Realtime updates verbroken',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Waarschuwing',
                    title: 'Uitloggen',
                    body: 'Als u uitlogt, worden alle artikelen verwijderd die aan uw winkelwagen zijn toegevoegd',
                    cancel: 'Annuleren',
                    proceed: 'Doorgaan',
                },
                order_restart: {
                    warning: 'Waarschuwing',
                    title: 'Bestelgegevens wijzigen',
                    body: 'Als u uw bestelgegevens verwijdert, worden de artikelen in uw winkelwagen verwijderd, omdat bepaalde artikelen niet meer beschikbaar zijn',
                    cancel: 'Annuleren',
                    proceed: 'Doorgaan',
                },
                order_expired: {
                    subtitle: 'Belangrijk',
                    title: 'Bestelling gewijzigd naar onmiddellijke inleveren',
                    description: 'Het geselecteerde tijdstip voor uw bestelling is nu niet ver weg. Als zodanig is uw bestelling gewijzigd naar onmiddellijk / zo snel mogelijk',
                    button: 'OK',
                },
                order_expiring: {
                    subtitle: 'Belangrijk',
                    title: 'Deadline voor bestellingen loopt binnenkort af',
                    description: 'Uw bestelling moet vóór {{time, timeFromTimestamp}} worden geplaatst, anders is deze niet langer geldig',
                    button: 'OK',
                },
                location_permission: {
                    cancel: 'Annuleren',
                    proceed: 'Doorgaan',
                },
            },
            card_payment_authentication: {
                title: 'Betalingsauthenticatie',
                note: 'Houd dit venster open totdat het authenticatieproces van uw bank is voltooid.',
            },
            maps: {
                cancel: 'Annuleren',
                use_location: 'Gebruik Locatie',
            },
            app_refresh: {
                refresh: 'Vernieuwen',
                title: 'Winkel vernieuwen',
                description: 'Onze winkel heeft een update ondergaan. Vernieuw uw browser om toegang te krijgen tot de meest recente versie. Na het vernieuwen moet u mogelijk uw winkelwagen opnieuw openen om door te gaan met het afrekenproces.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Gast',
                login: 'Login',
                login_signup: 'Inloggen / Aanmelden',
                logout: 'Uitloggen',
            },
            menus: {
                info: {
                    no_menus: 'Er zijn momenteel geen menu\'s beschikbaar',
                    restrictions: 'Menubeperkingen',
                    not_available: 'Menu niet beschikbaar',
                    unavailable: {
                        times: "Menu niet beschikbaar, uw bestelvereisten komen niet overeen met de onderstaande",
                        services: "Menu niet beschikbaar, uw bestelvereisten komen niet overeen met de onderstaande",
                        hours: 'Menu niet beschikbaar, uw bestellingen vallen niet binnen deze beschikbare uren van het menu',
                        pre_order: "Menu unavailable, your order doesn't match the pre-order requirements",
                        age: 'Menu niet beschikbaar. U moet ingelogd zijn met een leeftijdsgeverifieerd account om vanuit dit menu te kunnen bestellen',
                    },
                    services: {
                        title: 'Bestelvereisten',
                        pickup: 'Pick-ups',
                        delivery: 'Leveringen',
                        dine_in: 'Dineren',
                    },
                    times: {
                        now: 'Geen voorbestellingen',
                        later: 'Alleen pre-orders',
                    },
                    hours: {
                        title: 'Beschikbare uren',
                    },
                    preorder: {
                        title: 'Vereisten voor vooraf bestellen',
                        days_in_advance: 'Moet {{days}} dagen van tevoren bestellen',
                        cutoff_time: 'Uiterste begin van de laatste dag om {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Leeftijd beperkt',
                        approved: 'Uw account is feitelijk en u kunt via dit menu bestellen',
                        rejected: 'Vereist leeftijdsverificatie om te bestellen. Maak een account aan en upload uw ID',
                    },
                },
                search: {
                    title: 'Ontdek menu-items',
                    no_result: 'Er kwam niets terug. Een andere zoekterm proberen?',
                    placeholder: 'Waar bent u naar op zoek?',
                },
            },
            category: {
                restrictions: 'Categoriebeperkingen',
                not_available: 'Categorie niet beschikbaar',
                unavailable: {
                    services: "Categorie niet beschikbaar, uw bestelvereisten komen niet overeen met de onderstaande",
                    hours: "Categorie niet beschikbaar, uw besteluren vallen niet binnen deze categorie's beschikbare uren",
                },
            },
            info: {
                location: {
                    title: 'Locatie',
                    view_map: 'Bekijk kaart',
                    phone: 'Telefoon',
                },
                hours: {
                    title: 'Openingstijden',
                    title_special: 'Speciale openingstijden',
                },
                services: {
                    title: 'Diensten',
                    notes: 'Opmerkingen',
                    delivery: {
                        ranges: 'Leveringsbereiken',
                        zones: 'Leveringszones',
                        view_zones: 'Bekijk zones op de kaart',
                        fee: 'Bezorgkosten',
                        fee_short: 'Kosten',
                        fee_varies: 'Varieert, weergegeven in winkelwagen',
                        min_order: 'Minimale bestelling',
                        min_order_short: 'Min. best.',
                        no_min_order: 'Geen minimale bestelling',
                        free_amount: 'Gratis leveringsbedrag',
                    },
                },
            },
            contact: {
                title: 'Neem contact op met ons op',
                name: 'Naam',
                email: 'E-mail',
                phone: 'Telefoonnummer',
                message: 'Voer uw bericht in...',
                send: 'Bericht verzenden',
                success: 'Uw bericht is succesvol verzonden',
                error: 'Er is iets misgegaan. Probeer het opnieuw of op een later begin',
            },
            footer: {
                powered_by: 'Aangedreven deur',
                terms_and_conditions: 'Algemene voorwaarden',
                privacy: 'Privacybeleid',
                cookie: 'Cookiebeleid',
            },
        },
        pages: {
            payment_completed: {
                title: 'Uw betaling is verwerkt. Bedankt voor uw bestelling!',
                subtitle: 'De bestelinformatie wordt naar uw e-mailadres verzonden.',
                back_to_menu: 'Terug naar Menu',
                close_tab: 'Sluit dit onderzoek',
            },
            payment_failed: {
                title: 'Helaas is er een fout opgetreden bij het verwerken van uw betaling.',
                subtitle: '',
                back_to_menu: 'Terug naar Menu',
                close_tab: 'Sluit dit onderzoek',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Boekingsbewijs',
            details: {
                datetime: 'Boeken voor',
                number_of_people: 'Aantal mensen',
                placed: 'Geplaatst',
                updated: 'Laatst bijgewerkt',
                notes: 'Opmerkingen',
                name: 'Naam',
                email: 'E-mail',
                phone: 'Telefoon',
                store_address: 'Winkeladres',
            },
            status_update: {
                title: 'Boeking {{number}} Geüpdatet',
                body: 'Uw boekingsstatus is bijgewerkt naar {{status}}',
            },
            email_common: {
                name: 'Naam: {{name}}',
                phone: 'Telefoon: {{number}}',
                number_of_people: 'Aantal personen: {{number}}',
                date: 'Datum: {{date}}',
                time: 'Tijd: {{time}}',
                location: 'Winkellocatie: {{name}}',
                notes: 'Opmerkingen: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Nieuwe tafelboeking {{number}} deur {{name}}',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Nieuwe tafelboekingsaanvraag',
                title: 'Nieuwe boeking voor {{name}}',
                subtitle: 'Boekingsnummer {{number}}',
                description_confirmed: 'De boeking is automatisch bevestigd. U kunt deze annuleren via het beheerdersdashboard en uw klant wordt per e-mail op de hoogte gebracht',
                description_unconfirmed: 'Bevestig of annuleer de boeking via het beheerdersdashboard',
                url_pre_text: 'Bekijk en update op',
            },
            email_new_booking_customer: {
                subject: 'Tafelboekingsaanvraag',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Nieuwe tafelboekingsaanvraag',
                title: 'Bedankt voor uw boeking',
                subtitle: 'Boekingsnummer {{number}}',
                description: '<b>U ontvangt nog een e-mail wanneer uw boeking is bevestigd of afgewezen.</b><br>Neem contact met ons op als u wijzigingen in uw boeking wilt aanbrengen. De details van uw boeking zijn als volgt:',
                url_pre_text: 'U kunt uw realtime boekingsbewijs bekijken op',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Tafelboeking bevestigd',
                subject_unconfirmed: 'Tafelboeking geannuleerd',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Tafelboekingsaanvraag',
                title_confirmed: 'Boeking bevestigd',
                title_unconfirmed: 'Boeking geannuleerd',
                subtitle: 'Boekingsnummer {{number}}',
                description_confirmed: 'Wij kijken ernaar uit u te zien. Neem contact met ons op om eventuele wijzigingen in uw boeking aan te vragen',
                description_unconfirmed: 'Het spijt ons u te moeten mededelen dat uw boekingsaanvraag niet kon worden geaccepteerd. Onze excuses voor het eventuele ongemak. Neem contact met ons op als u vragen heeft',
                url_pre_text: 'U kunt uw realtime boekingsbewijs bekijken op',
            },
            email_status_update_customer: {
                subject: 'Reservering #{{number}} – {{subjectLabel}}',
                body: 'Je reservering #{{number}} bij {{store}} is nu {{status}}.',
            },
            errors: {},
            status_warning: 'Update de status van deze boeking in uw beheerdersdashboard op de boekingspagina',
        },
    },
    email_delayed_order: {
        subject: 'Bestelling #{{number}} – {{subjectLabel}}',
        header: 'Bijgewerkte bereidingstijd',
        title: 'Bijgewerkte bereidingstijd',
        order_number: 'Bestelnummer: {{number}}',
        description: 'Je bestelling is nu klaar om {{time}}.',
        order_time_updated_to: 'De tijd van je bestelling is bijgewerkt.',
        powered_by: 'Mogelijk gemaakt door {{name}}',
        button_text: 'Volg bestelling',
        subject_label: 'Bijgewerkte bereidingstijd',
        subject_label_delivery: 'Bijgewerkte levertijd',
        body_ready: 'Je bestelling is nu klaar om {{time}}.',
        body_delivery: 'Je bestelling wordt nu geleverd om {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Geschat. Klaar tijd',
            est_driver_pickup_time: 'Geschat. Ophaaltijd chauffeur',
            est_delivery_time: 'Geschat. Levertijd',
            tab_details: 'Details',
            tab_dishes: 'Artikelen',
            future_order: 'Toekomstige bestelling',
            reprint: 'HERDRUK',
            details: {
                order_no: 'Bestelnr.',
                status: 'Status',
                placed: 'Geplaatst',
                due: 'Vanwege',
                due_asap: 'Nu/zo snel mogelijk',
                last_updated: 'Laatst bijgewerkt',
                total: 'Totaal',
                type: 'Type',
                origin: 'Oorsprong',
                table: 'Tafel',
                number_of_people: 'Aantal mensen',
                payment_method: 'Betaalmethode',
                payment_status: 'Betalingsstatus',
                payment_currency: 'Betalingswaarde',
                notes: 'Opmerkingen',
                name: 'Naam',
                email: 'E-mail',
                phone: 'Telefoon',
                distance: 'Afstand',
                driving_time: 'Rijtijd',
                delivery_zone: 'Bezorgzone',
                delivery_address: 'Afleveradres',
                delivery_provider: 'Bezorgaanbieder',
                delivery_tracking: 'Levering volgen',
                delivery_return_tracking: 'Volg de terugkeer',
                delivery_tracking_link: 'Volg bestelling',
                tookan_status: 'Tookan-status',
                tookan_status_failed_book: 'Het is niet gelukt om de levering te boeken',
                tookan_status_failed_update: 'Kan de boeking niet bijwerken',
                tookan_status_success: 'Boekt voor bezorging',
                store_address: 'Winkeladres',
                destination: 'Bestemming',
                estimated_arrival_time: 'Schatting van de moeite',
                delivery_status: 'Bezorgstatus',
                delivery_track_your_order: 'Volg uw bestelling',
                delivery_text: 'Levering',
                arrival_date: 'Aankomstdatum',
            },
            dishes: {
                headings: {
                    quantity: 'Aantal',
                    item: 'Artikel',
                    price: 'Prijs',
                },
                notes: 'Opmerkingen',
                remove_ingredients: 'Ingrediënten verwijderen',
            },
            status_update: {
                title: 'Bestelling {{number}} Geupdatet',
                body: 'Uw bestelstatus is bijgewerkt naar {{status}}',
            },
            wait_time_update: {
                title: 'Bestelling {{number}} Geupdatet',
                body: 'De vervaldatum van uw bestelling is bijgewerkt',
            },
            delivery_update: {
                title: 'Bestelling {{number}} Geupdatet',
                body: 'Uw bestelling is gereserveerd voor bezorging. Zie realtime trackinglink',
            },
            payment_status_update: {
                title: 'Bestelling {{number}} Geupdatet',
                body: 'De betalingsstatus van uw bestelling is bijgewerkt.',
            },
            email_new_order_restaurant: {
                subject: 'Nieuwe bestelling ({{number}}) - {{name}}',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Nieuwe bestelling doorgeven',
                title: 'Nieuwe bestelling geplaatst op {{name}}',
                subtitle: 'Bestelnummer {{number}}',
                description: 'Bekijk details en updates via uw beheerdersdashboard',
                button_text: 'Volg bestelling',
                track_delivery_button_text: 'Volg de levering',
            },
            email_new_order_customer: {
                subject: 'Bestelbon ({{number}})',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Nieuwe bestelling doorgeven',
                title: 'Nieuwe bestelling geplaatst op {{name}}',
                subtitle: 'Bestelnummer {{number}}',
                description: 'Bekijk details en updates via uw realtime online betalingsbewijs',
                button_text: 'Volg bestelling',
                track_delivery_button_text: 'Volg de levering',
            },
            email_order_completed_by_customer: {
                subject: 'Bestelling ({{number}}) Voltooid deur klant',
                powered_by: 'Mogelijk gemaakt door {{name}}',
                overview: 'Bestelling voltooide melding',
                title: 'Bestelling voltooid op {{name}}',
                subtitle: 'Bestelnummer {{number}}',
                description: 'Bekijk details en update uw bestelling via uw dashboard of via de kassabon op',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) incl. qua prijs',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Bezorgkosten',
            delivery_fee_offset: 'Korting op bezorgkosten',
            delivery_fee_total: 'Bezorgkosten Totaal',
            promo: 'Korting: {{name}} ({{value, currency}} + {{percent}}% korting)',
            promo_percent: 'Korting: {{name}} ({{percent}}%)',
            promo_fixed: 'Korting: {{name}}',
            promo_none: 'Korting: {{name}}',
            cart: 'Winkelwagen',
            tip: 'Besteltip',
            total: 'Totaal',
        },
        status: {
            unconfirmed: 'Niet bevestigd',
            awaiting_payment: 'In afwachting van betaling',
            confirmed: 'Bevestigd',
            ready: 'Klaar',
            on_route: 'Op route',
            complete: 'Compleet',
            cancelled: 'Geannuleerd',
            seated: 'Gezeten',
        },
        searching: {
            lalamove_search_placeholder: 'Zoek bestelling op Lalamove-bezorg-ID',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Niet beschikbaar',
                },
            },
            dish: {
                no_stock: 'Niet op voorraad',
                not_available: 'Niet beschikbaar',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-mailbevestigingscode',
            register_confirmation_code_email: 'Uw e-mailbevestigingscode is {{confirmation_code}} (loopt ruim 24 uur)',
            register_confirmation_code_email_onbehalf: 'Uw e-mailbevestigingscode is {{confirmation_code}} (verloopt over 24 uur). Dit is voor het e-mailadres, {{email}}.',
        },
    },
};
//# sourceMappingURL=nl.js.map